<template>
  <div class="page mypage password_update px-3 pb-3 pt-10">
    <page-header
      has-back>
      パスワード変更
    </page-header>
    <p>現在お使いのパスワードを変更します。</p>
    <p class="fs-s">
      ・パスワードは8文字以上で入力してください<br>
      ・英字と数字を含めてください
    </p>
    <div class="mypage__body general-form">
      <form>
        <validation-observer v-slot="observer">
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="old_password"
              class="col-form-label">現在のパスワード</label>
            <validation-provider
              ref="old_password" 
              v-slot="v"
              name="現在のパスワード"
              rules="password|required">
              <b-form-input
                v-model="old_password"
                type="password" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="new_password1"
              class="col-form-label">新しいパスワード</label>
            <validation-provider
              ref="new_password1" 
              v-slot="v"
              name="新しいパスワード" 
              rules="password|required">
              <b-form-input
                v-model="new_password1"
                type="password" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="new_password2"
              class="col-form-label">新しいパスワード（確認）</label>
            <validation-provider
              ref="new_password2"
              v-slot="v"  
              name="新しいパスワード（確認）"
              rules="confirmed:new_password2"
              vid="new_password2">
              <b-form-input
                v-model="new_password2"
                type="password" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__btn row mt-5">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-cancel"
                @click="onClickCancel">
                キャンセル
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                保存
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/parts/PageHeader.vue'
export default {
  components: {
    PageHeader
  },
  data() {
    return {
      old_password: '',
      new_password1: '',
      new_password2: ''
    }
  },
  methods: {
    onClickCancel() {
      this.$router.back()
    },
    async onClickSave() {
      this.$store.commit('startLoading')
      this.$axios.post('/auth/password/change/', {old_password: this.old_password, new_password1: this.new_password1, new_password2: this.new_password2})
        .then(() => {
          this.$store.commit('notify/set', {message: 'パスワードの更新が完了しました。'})
          this.$router.push('/settings/')
        })
        .catch((e) => {
          if (e.response && e.response.data){
            if (e.response.data.oldPassword){
              this.$refs.old_password.applyResult({
                errors: e.response.data.oldPassword,
                valid: false,
                failedRules: {}
              })
            }
            if (e.response.data.newPassword1){
              this.$refs.new_password1.applyResult({
                errors: e.response.data.newPassword1,
                valid: false,
                failedRules: {}
              })
            }
            if (e.response.data.newPassword2){
              this.$refs.new_password2.applyResult({
                errors: e.response.data.newPassword2,
                valid: false,
                failedRules: {}
              })
            }
          } else {
            this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          }
        }).finally(() => {
          this.$store.commit('finishLoading')
        })
    }, 
  }
}
</script>
<style lang="scss" scoped>
</style>